import React from "react";
import FaqItem from "./FaqItem";

import rewardImage from "../imgs/reward.jpeg";
import PopText from "./PopText";

const FAQ = () => {
  return (
    <div className="bg-[#052035] py-16" id="faq">
      <div className="mx-auto max-w-7xl">
        <h1 className="text-white font-bold text-3xl lg:text-4xl text-center pb-8">
          Why <span className="text-[#3BF5CA] font-bold">Hallimo</span>?
        </h1>

        <div className="px-5 lg:px-14">
          <div
            className="px-6 pb-10 w-full h-[420px] flex flex-col justify-end rounded-2xl mt-4 mb-10 relative"
            style={{
              backgroundImage: `url(${rewardImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute top-5 right-6 flex flex-col">
              <PopText
                color={"orange"}
                name={"Ifeoma"}
                text={"Congrats, you've received a discount on this course"}
                main
              />

              <PopText
                color={"red"}
                name={"Larry"}
                text={"Congrats, you've earned an internship in UI/UX"}
              />
            </div>

            <h1 className="text-white text-3xl lg:text-6xl mb-2">
              Earn rewards that matter
            </h1>
            <p className="text-sm lg:text-base text-white">
              Access real-world incentives that motivate and align with your
              goals.
            </p>
          </div>
        </div>

        <h1 className="text-white font-bold text-3xl lg:text-4xl text-center lg:text-start pb-1 mt-20">
          Frequently Asked Questions
        </h1>

        <div className="px-5 lg:px-0">
          <div className="w-full lg:w-[60%]">
            <FaqItem
              title="How does Hallimo work?"
              subtitle={`Hallimo is a test-to-earn platform designed specifically for learners in the creative arts and tech industries. You can take curated quizzes to test your skills, participate in community challenges, and play bonus games to earn Hallimo Points.`}
              subtitle2={`These points can be redeemed for real-world rewards such as vouchers, courses, templates, internships, and more. Hallimo not only helps you refine your knowledge but also aligns with your professional and personal goals by providing meaningful incentives.`}
            />
            <FaqItem
              title="Who can join Hallimo?"
              subtitle="Hallimo is open to students, freelancers, and lifelong learners aged 13 and above who are passionate about the creative arts or technology. Whether you're a beginner looking to grow or an experienced professional aiming to sharpen your skills, Hallimo provides a supportive space to learn, test, and earn rewards."
            />
            <FaqItem
              title="What kind of rewards can I earn?"
              subtitle="Hallimo offers real-world rewards like vouchers, access to courses, productivity templates, internships, exclusive merchandise, and much more, all tailored to your interests and goals. You must be signed up to view the full list of available rewards."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
